import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import StructuredData from './components/StructuredData';
import usePageTitle from './hooks/usePageTitle';

// Import CSS files
import './css/main.css';
import './css/responsive.css';
import './App.css';

function App() {
  const [language, setLanguage] = useState('fr'); // Default to French
  
  // Update page title and meta based on language
  usePageTitle(language);

  return (
    <Router>
      <div className="App">
        <StructuredData language={language} />
        <Header language={language} setLanguage={setLanguage} />
        
        <main>
          <Routes>
            <Route path="/" element={<Home language={language} />} />
          </Routes>
        </main>
        
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;
